<template>
  <div
    class="delivery-days-selector"
    :class="elClass"
  >
    <p v-if="!isEmptyMode" class="delivery-days-selector__title">
      {{ title }}
    </p>
    <div class="delivery-days-selector__body">
      <div>
        <div class="delivery-days-selector__calendar">
          <DeliveryCalendar
            type="checkout"
            drop-down-mode="modal"
            :options="calendarOptions"
            :selected-day-params="selectedDeliveryDate || defaultDeliveryDate"
            :delivery-days="deliveryDays"
            @setDeliveryDateParams="setDeliveryDate"
            @click.once="onDeliveryCalendarClick"
          />
        </div>
        <p
          v-if="!isEmptyMode"
          class="delivery-days-selector__description"
        >
          <template v-if="isWelcomeSet">
            Набор еды на 2 дня из нашего самого популярного меню. Отлично подойдёт для тех, кто хочет попробовать GrowFood.
          </template>
          <template v-else>
            А дальше мы будем привозить вам коробку вкусной и полезной еды каждые {{ $numberLingFormWithNumberFunc(numberOfDaysInDelivery, 'день', 'дня', 'дней') }}
          </template>
        </p>
      </div>
      <img
        v-if="!isEmptyMode"
        src="@/assets/images/newOrder/delivery-box.png"
        alt=""
        height="97"
        class="delivery-days-selector__image"
      >
    </div>
  </div>
</template>

<script>
import DeliveryCalendar from '@/components/core/lib/Calendar/Calendar'

import { DaySessions, Times } from '@/config/constants'
import { provide } from 'vue'

const TITLE = 'Доставка бесплатно'

export default {
  name: 'DeliveryDaysSelector',

  components: {
    DeliveryCalendar,
  },

  props: {
    menu: {
      type: Object,
      required: true,
    },

    deliveryDays: {
      type: Object,
      required: true,
    },

    numberOfDaysInDelivery: {
      type: Number,
      default: 2,
    },

    selectedDeliveryDate: {
      type: Object,
      default: null,
    },

    isWelcomeSet: {
      type: Boolean,
      default: false,
    },

    isEmptyMode: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['select'],

  setup (props) {
    provide('config', props.menu?.config || {})
  },

  data () {
    return {
      title: TITLE,
    }
  },

  computed: {
    defaultDeliveryDate () {
      return {
        date: this.menu?.firstDeliveryDate,
        timeFrom: this.menu?.dayTime === DaySessions.MORNING ? Times.SEVEN_AM : Times.SIX_PM,
      }
    },

    calendarOptions () {
      return {
        datePresentation: 'newOrder',
      }
    },

    elClass () {
      return {
        'delivery-days-selector--empty-mode': this.isEmptyMode,
      }
    },
  },

  methods: {
    setDeliveryDate (date) {
      this.$emit('select', date)
    },

    onDeliveryCalendarClick () {
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'delivery_date',
        action: 'click',
      })
    },
  },
}
</script>

<style lang="scss">
.delivery-days-selector {
  $self: &;
  margin: 32px 0;

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 6px;
  }

  &__body {
    display: flex;
    justify-content: space-between;
  }

  &__image {
    width: 120px;
  }

  &__calendar {
    color: map-get($colors, 'default');
    margin: 12px 0 8px;

    .core-dropdown-v2__button {
      padding: unset;
      background: map-get($colors, 'white');
      border: unset;
      color: map-get($colors, 'default');

      .core-dropdown-v2__content-slot {
        width: unset;
      }

      .select-day-presentation-title {
        padding-left: unset;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }

    .core-dropdown-v2__button-right-icon {
      width: unset;
      margin-left: 4px;
      color: map-get($colors, 'default');

      .c-icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__description {
    color: map-get($colors, 'grey_60');
    font-size: 12px;
    line-height: 16px;
  }
  &--empty-mode {
    margin: 16px 0 0;
    #{$self}__calendar {
      margin: 0;
      .core-dropdown-v2__button {
        padding: 10px 30px;
        border-radius: 16px;
        color: map-get($colors, 'black');
        background: map-get($colors, 'grey_4');
        justify-content: center;
      }
      .core-dropdown-v2__button-right-icon {
        color: map-get($colors, 'grey_40');
      }
    }
    #{$self}__body {
      display: block;
    }
  }
}
</style>
